import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/asuetos/asuetos';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.asuetos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
